import { render, staticRenderFns } from "./DemoBand.vue?vue&type=template&id=568c12fa&scoped=true"
import script from "./DemoBand.vue?vue&type=script&lang=js"
export * from "./DemoBand.vue?vue&type=script&lang=js"
import style0 from "./DemoBand.vue?vue&type=style&index=0&id=568c12fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568c12fa",
  null
  
)

export default component.exports